import React from 'react';
import { missionVision } from '../data/mock';
import { Target, Eye } from 'lucide-react';

const MissionSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#F8F7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <p className="text-sm tracking-[0.2em] text-[#6B8F71] mb-4 uppercase">
            Our Purpose
          </p>
          <h2 className="text-3xl lg:text-4xl font-light text-[#333333]">
            Guiding Principles
          </h2>
        </div>

        {/* Mission & Vision Cards */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Mission */}
          <div className="bg-[#FFFEF8] p-10 lg:p-12">
            <div className="w-14 h-14 mb-8 flex items-center justify-center bg-[#6B8F71]/10">
              <Target className="w-7 h-7 text-[#6B8F71]" />
            </div>
            <h3 className="text-2xl font-light text-[#333333] mb-6">
              {missionVision.mission.title}
            </h3>
            <p className="text-base text-[#666666] leading-relaxed">
              {missionVision.mission.description}
            </p>
          </div>

          {/* Vision */}
          <div className="bg-[#FFFEF8] p-10 lg:p-12">
            <div className="w-14 h-14 mb-8 flex items-center justify-center bg-[#B8A88A]/10">
              <Eye className="w-7 h-7 text-[#B8A88A]" />
            </div>
            <h3 className="text-2xl font-light text-[#333333] mb-6">
              {missionVision.vision.title}
            </h3>
            <p className="text-base text-[#666666] leading-relaxed">
              {missionVision.vision.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
